import { ForwardingBatchItemType } from '@ukpostbox/client-data/lib/Types/ForwardingBatchTypes';
import {
	Badge,
	ColourOutline,
	FlexGap,
	ItemRow,
	ItemRowCell,
	ItemRowSize,
	Pill,
	PillSize,
	Placement,
	StackVertical,
	useLayout,
	useTranslation,
} from '@ukpostbox/frontend-framework';
import React, { memo } from 'react';
import { ForwardingBatchContents } from './Controls/ForwardingBatchItemContents';

const ForwardingBatchItemMinimal = memo((props: ForwardingBatchItemType) => {
	const { t } = useTranslation();
	const { isTiny, isSmall, isMedium, isLarge, isXL } = useLayout();
	const statusColour =
		props.statusDescription === 'Forwarded'
			? ColourOutline.Success
			: props.statusDescription === 'Pending'
				? ColourOutline.Warning
				: ColourOutline.Alert;

	return (
		<ItemRow
			title={`Forward Batch Minimal Entry ${props.batchId}`}
			size={ItemRowSize.Large}
			highlighted={statusColour === ColourOutline.Alert}
			muted={statusColour !== ColourOutline.Alert}
			extraClass='forwarding-batch-item-row'
			extraProps={{
				draggable: false,
			}}
			actionLink={{ url: `/mail/forwarding-batches/${props.batchId}` }}
		>
			<ItemRowCell>
				<div style={{ position: 'relative' }}>
					{props.files.map((file, index) => (
						<ForwardingBatchContents {...file} />
					))}
					<Badge placement={Placement.BottomRight} value={props.itemsInBatch} />
				</div>
			</ItemRowCell>

			<ItemRowCell extraClass='mail-item-reference'>
				<StackVertical gap={FlexGap.ExtraSmall}>
					<strong className='mail-item-tracking-id'>{props.batchIdNo}</strong>
					<Pill
						content={t('status.dynamicType', { action: props.statusDescription })}
						colour={statusColour}
						size={PillSize.Small}
					/>
				</StackVertical>
			</ItemRowCell>

			{!isTiny && !isSmall && !isMedium && !isLarge && (
				<ItemRowCell>
					<StackVertical gap={FlexGap.ExtraSmall}>
						<small>Address</small>
						<span className='text-overflow'>{props.forwardingAddress.formatted}</span>
					</StackVertical>
				</ItemRowCell>
			)}

			{!isTiny && !isSmall && !isMedium && !isLarge && !isXL && (
				<ItemRowCell>
					<StackVertical gap={FlexGap.ExtraSmall}>
						<small>Postage</small>
						<span className='text-overflow'>{props.postageOption}</span>
					</StackVertical>
				</ItemRowCell>
			)}
		</ItemRow>
	);
});

export default ForwardingBatchItemMinimal;
